import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    padding: "12px 0 12px 0",
    "&::before": {
      content: "''",
      position: "absolute",
      top: 0,
      left: -24,
      right: -24,
      borderTop: `1px solid ${theme.palette.grey[200]}`,
    },
    "&:last-child::after": {
      content: "''",
      position: "absolute",
      bottom: 0,
      left: -24,
      right: -24,
      borderTop: `1px solid ${theme.palette.grey[200]}`,
    },
    [theme.breakpoints.up("md")]: {
      padding: "16px 0",
    },
  },
  top: {
    flex: 1,
    display: "flex",
  },
  check: {
    width: 32,
  },
  main: {
    flex: 1,
    minWidth: 1,
    paddingRight: 40,
  },
  name: {
    display: "inline-block",
    verticalAlign: "bottom",
    maxWidth: 300,
  },
  details: {
    flex: "0 0 44%",
  },
  detailsButton: {
    width: 24,
    height: 24,
    padding: 0,
    marginLeft: 8,
    "& svg": {
      width: 16,
      height: 16,
      color: theme.palette.primary.main,
    },
  },
  more: {
    flex: "0 0 24px",
    position: "relative",
  },
  moreButton: {
    width: 24,
    height: 24,
    padding: 0,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 4,
    "& svg": {
      width: 16,
      height: 16,
      color: theme.palette.grey[500],
    },
    "&:disabled": {
      opacity: 0.4,
    },
  },
  bottom: {
    position: "relative",
    paddingTop: 16,
    paddingLeft: 32,
  },
}));
